// components/Layout.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import Navigation from './Navigation';

const Layout = ({ children }) => {
  const { isDarkMode } = useTheme();
  const location = useLocation();
  
  // Return a simpler layout for the home page
  if (location.pathname === '/') {
    return (
      <div className={`min-h-screen ${isDarkMode ? 'dark' : ''}`}>
        {children}
      </div>
    );
  }

  return (
    <div className={`flex min-h-screen ${isDarkMode ? 'dark' : ''} 
      bg-gradient-to-br from-neutral-50 via-blue-50 to-neutral-100 
      dark:bg-gradient-to-br dark:from-neutral-900 dark:via-blue-950 dark:to-neutral-900 
      transition-colors duration-500`}>
      
      {/* Sidebar */}
      <aside className="hidden lg:block w-64 fixed h-full bg-white/90 dark:bg-neutral-800/90 
        backdrop-blur-md border-r border-neutral-200 dark:border-neutral-700 top-20"> {/* Adjusted top to account for nav */}
        <div className="p-6 flex flex-col h-full">
          {/* Artist Name */}
          <Link to="/" className="block text-2xl font-bold tracking-tight dark:text-white mb-6 text-center">
            EL Ceballos
          </Link>

          {/* Artist Image */}
          <div className="mb-8">
            <img 
              src="/main_image/Familia2.png" 
              alt="EL Ceballos" 
              className="w-full aspect-square object-cover shadow-lg"
              loading="eager"
            />
          </div>

          {/* Gallery Categories */}
          <nav className="space-y-4">
            {/* <h2 className="text-sm font-semibold text-neutral-500 dark:text-neutral-400 uppercase tracking-wider mb-2">
              <Link to="/gallery">Work</Link>
            </h2>
            
            <Link 
              to="/gallery/2d" 
              className={`block text-lg transition-colors
                ${location.pathname === '/gallery/2d' 
                  ? 'text-neutral-900 dark:text-white font-medium' 
                  : 'text-neutral-700 dark:text-neutral-300 hover:text-neutral-900 dark:hover:text-white'}`}
            >
              2D
            </Link>
            
            <Link 
              to="/gallery/video"
              className={`block text-lg transition-colors
                ${location.pathname === '/gallery/video' 
                  ? 'text-neutral-900 dark:text-white font-medium' 
                  : 'text-neutral-700 dark:text-neutral-300 hover:text-neutral-900 dark:hover:text-white'}`}
            >
              Video
            </Link>

            <Link 
              to="/gallery/3d"
              className={`block text-lg transition-colors
                ${location.pathname === '/gallery/3d' 
                  ? 'text-neutral-900 dark:text-white font-medium' 
                  : 'text-neutral-700 dark:text-neutral-300 hover:text-neutral-900 dark:hover:text-white'}`}
            >
              3D
            </Link> */}

            <div className="pt-4 border-t border-neutral-200 dark:border-neutral-700">
              <Link 
                to="/about"
                className={`block text-lg transition-colors
                  ${location.pathname === '/about' 
                    ? 'text-neutral-900 dark:text-white font-medium' 
                    : 'text-neutral-700 dark:text-neutral-300 hover:text-neutral-900 dark:hover:text-white'}`}
              >
                About
              </Link>
              
              
            </div>
          </nav>

          {/* Footer */}
          <div className="mt-auto pt-6 text-sm text-neutral-500 dark:text-neutral-400">
            © {new Date().getFullYear()} EL Ceballos
          </div>
        </div>
      </aside>

      {/* Navigation - Now visible on all screen sizes */}
      <Navigation />

      {/* Main Content - Adjusted padding for navigation bar */}
      <main className="flex-1 lg:ml-64">
        <div className="pt-20 px-4 lg:px-8"> {/* Added pt-20 for navigation spacing */}
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;